import React from 'react';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { filterOptions, FilterType, job_dates } from 'components/breadcrumbs/constants';
import { MegaMenu } from 'components/mega-menu/megaMenu';
import { BreadcrumbTooltip } from 'components/tooltips/BreadcrumbTooltip';
import { useAppDispatch, useAppSelector } from 'ducks/hooks';
import { clearJob } from 'ducks/job/slices';
import { setModal } from 'ducks/modals/slices';
import { selectProject } from 'ducks/project/selectors';
import { selectProjects } from 'ducks/projects/selectors';
import { JobsQuery } from 'ducks/types/query-types';
import { useLocation, useParams } from 'react-router-dom';
import { parseQueries } from 'utils/queries';

import cn from 'components/breadcrumbs/Breadcrumbs.module.scss';

interface ParamsProps {
  job_state?: FilterType;
}

export const Jobs = () => {
  const dispatch = useAppDispatch();
  const { search } = useLocation();
  const params: ParamsProps = useParams();

  const project = useAppSelector(selectProject);
  const projects = useAppSelector(selectProjects);

  const handleParams = (filter: FilterType) => {
    return filterOptions[filter as keyof typeof filter];
  };

  const handleRunJobDefinition = () => {
    dispatch(clearJob());
    dispatch(setModal({ run_job_definition: true }));
  };

  const job_state = params.job_state && handleParams(params.job_state);
  const { range_name } = parseQueries<JobsQuery>(search);
  const project_name = `${project.project_name ?? 'Projects'}`;
  return (
    <>
      <div className={cn.items}>
        <MegaMenu labels={project_name} values={projects} page="jobs" />
        <FontAwesomeIcon className={cn.breadcrumbIcon} icon={faChevronRight} />
        <div className={cn.breadcrumb}>Jobs: {job_state}</div>
        <FontAwesomeIcon className={cn.breadcrumbIcon} icon={faChevronRight} />
        <MegaMenu labels={range_name || 'Date Range'} values={job_dates} page="jobs_range" />
        <div className={cn.flexGrow} />
      </div>
      <div className={cn.circle} onClick={handleRunJobDefinition}>
        <BreadcrumbTooltip tooltip="Run New Job" />
      </div>
    </>
  );
};
